import dayjs from "@gtmhub/dayjs";
import { Milestone } from "@webapp/okrs/metrics/components/metric-milestone/metric-milestone.models";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";

type Meta = {
  nextMilestone: Milestone | null;
};

const getNextMilestone = (milestones: Milestone[], date: Date): Milestone | null => {
  let closestMilestone: Milestone | null = null;
  milestones.forEach((milestone) => {
    if (dayjs(milestone.date).toDate().getTime() > date.getTime() && (!closestMilestone || dayjs(closestMilestone?.date) > dayjs(milestone.date))) {
      closestMilestone = milestone;
    }
  });
  return closestMilestone;
};

export const calculateDelta = (milestoneTargetValue: number, currentValue: number): number => {
  return parseFloat((currentValue - milestoneTargetValue).toFixed(2));
};

export const setNextMilestone = (meta: Meta, metric: Metric, updatedAt: string): void => {
  if (metric.milestones?.length) {
    meta.nextMilestone = getNextMilestone(metric.milestones, dayjs(updatedAt).toDate()) || { targetValue: metric.target, date: dayjs(metric.dueDate).toDate() };
  }
};
